import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import "./roleView.css";
import NextIcon from "../../../../assets/images/next-icon.svg";
import { RoleManageViewContext } from "../ViewRoleView";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteAlertBox from "../../../../components/AlertComponent/AlertBox";
import Loader from "../../../../components/Loader/Loader";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeleteIcon from "../../../../assets/images/deleteIcon.png";
import DeletePopupImage from "../../../../assets/images/delete.svg";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const RoleManageView = () => {
  const {
    roleData,
    errorPopup,
    errorPopupMessage,
    roleId,
    setErrorPopup,
    viewRole,
    roleTableList,
    roleToLogin,
    statusValue,
    successPopup,
    SuccessAlert,
    successPopupMessage,
    buttonText,
    spinnerStatus,
    setSuccessPopup,
    deleteRoleManage,
    editRoleData,
    deleteAlert,
    setDeleteAlert,
    featuresData,
    userPermissionList,
    permissionAccess,
  } = useContext(RoleManageViewContext);

  return (
    <div className="pageBg roleViewPage">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={roleTableList}>
          {ContentData.rolePermissions.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.roleDetail}
        </span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <button type="button" onClick={roleTableList} class="navbar-btn">
              <img src={ToggleArrow} alt="toggle-arrow" />
            </button>
            <div className="pageTittles">
              {roleData?.name ? roleData?.name : "-"}
            </div>
            <div className="subFlexing">
              <div
                className={`deletEditSection ${
                  permissionAccess?.edit ? "" : "disabledIconOnly"
                }`}
                onClick={() => editRoleData(roleData._id)}
              >
                <img src={EditIcon} alt="edit" />
              </div>
              <div
                className={`deletEditSection ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
                onClick={() => setDeleteAlert(true)}
              >
                <img src={DeleteIcon} alt="delete" />
              </div>
            </div>
          </div>
        </div>
        <div className="basicContainer">
          <div className="viewDetailSection">
            <Row>
              <Col xxl="3" xl="6" lg="12" sm="12">
                <div className="adminDetailSection mb-5">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.rolePermissions?.roleName}</h4>
                    <h5>{roleData?.name ? roleData?.name : "-"}</h5>
                  </div>
                </div>
              </Col>
              <Col xxl="12" xl="12" lg="12" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.rolePermissions?.description}</h4>
                    <h5>
                      {roleData?.description ? roleData?.description : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="basicContainer">
          <div className="subHead">
            {ContentData.rolePermissions.permissionHead}
          </div>
          {featuresData?.map((feature, index) => {
            // Find the matching permission in userPermissionList based on feature ID
            const userPermission = userPermissionList.find(
              (permission) => permission.feature._id === feature._id
            );

            return (
              <div key={index} className="flexPermission">
                <div className="roleNameChoose">
                  <span>{feature.name ? feature.name : "Unknown Feature"}</span>
                </div>
                <div className="rolePermissions">
                  <div className="checkBoxDataPerm">
                    <CheckBox
                      label="View"
                      check={userPermission?.view || false}
                      id={feature.name + "_view"}
                      disabled={true}
                    />
                  </div>
                  <div className="checkBoxDataPerm">
                    <CheckBox
                      label="Add"
                      check={userPermission?.add || false}
                      id={feature.name + "_add"}
                      disabled={true}
                    />
                  </div>
                  <div className="checkBoxDataPerm">
                    <CheckBox
                      label="Edit"
                      check={userPermission?.edit || false}
                      id={feature.name + "_edit"}
                      disabled={true}
                    />
                  </div>
                  <div className="checkBoxDataPerm">
                    <CheckBox
                      label="Delete"
                      check={userPermission?.delete || false}
                      id={feature.name + "_delete"}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
      <SuccessPopupAlert
        show={successPopup}
        alertMessage={successPopupMessage}
        handleSubmit={() => {
          setSuccessPopup(false);
          roleTableList();
        }}
      />
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401) {
            roleToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            viewRole(roleId);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
      <DeleteAlertBox
        alertMessage={ContentData.rolePermissions.deleteSure}
        buttonSubmitText={ContentData.rolePermissions.deleteText}
        popImage={DeletePopupImage}
        show={deleteAlert}
        setShow={setDeleteAlert}
        handleSubmitData={() => deleteRoleManage(roleData._id)}
        handleCancelClick={() => setDeleteAlert(false)}
      />
    </div>
  );
};

export default RoleManageView;
